import { BeezerIcon } from "@/components/atoms/BeezerIcon"
import { SpotifyIcon } from "@/components/atoms/SpotifyIcon"

export const ValidateIcon = ({ isGuest }: { isGuest: boolean }) => {
    return (
        <>
            {
                isGuest ? <BeezerIcon width='40' height='40' />
                    : <SpotifyIcon width='15' height='20' />
            }
        </>
    )
}
